import { createSignal } from 'solid-js'
import type { InsufficientCreditsError } from '../../api/types/credits'

export class PaymentRequiredError extends Error {
  public readonly code = 'PAYMENT_REQUIRED'

  constructor(public body: InsufficientCreditsError) {
    super(body.error)
    this.name = 'PaymentRequiredError'
  }
}

const [paymentRequired, setPaymentRequired] = createSignal<InsufficientCreditsError | null>(null)

export { paymentRequired, setPaymentRequired }
